// extracted by mini-css-extract-plugin
module.exports = {"phoneInput":"phoneInput_phoneInput__tuXf7","wrapper":"phoneInput_wrapper__z0Pea","plus":"phoneInput_plus__EzWes"};